<section>
  <div class="container">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-12">
          <div class="user-dashboard-info-box">
            <div class="section-title-02 mb-4">
              <h4>{{headerText}}</h4>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>Type*</label>
                    <select class="form-control basic-select" formControlName="type"
                      [class.is-invalid]="(form.controls['type']?.errors || form.controls['type']?.errors?.required)">
                      <option *ngFor="let jobType of lookupStore.jobTypes | async" [ngValue]="jobType.id">
                        {{jobType.value}}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>Title*</label>
                    <input type="text" class="form-control" formControlName="title"
                      [class.is-invalid]="(form.controls['title']?.errors || form.controls['title']?.errors?.required)">
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>Description*</label>
                    <textarea class="form-control" rows="4" formControlName="description"
                      [class.is-invalid]="(form.controls['description']?.errors || form.controls['description']?.errors?.required)"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6 top-padding-only">
                    <label>Languages*</label>
                    <ng-multiselect-dropdown formControlName="languages" class="form-control"
                      [class.is-invalid]="(form.controls['languages']?.errors || form.controls['languages']?.errors?.required)"
                      [settings]="languageddlSettings" [data]="languagesList" [(ngModel)]="selectedLanguages"
                      (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)"
                      (onDeSelect)="onDeSelect($event)">
                    </ng-multiselect-dropdown>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Sector*</label>
                    <select class="form-control basic-select" formControlName="sector"
                      [class.is-invalid]="(form.controls['sector']?.errors || form.controls['sector']?.errors?.required)">
                      <option *ngFor="let sector of lookupStore.sectors | async" [ngValue]="sector.id">{{sector.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>Skills</label>
                    <job-skills-form [jobSkills]="jobSkills"></job-skills-form>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6 select-border float-left">
                    <label>Experience*</label>
                    <select class="form-control basic-select" formControlName="experience"
                      [class.is-invalid]="(form.controls['experience']?.errors || form.controls['experience']?.errors?.required)">
                      <option *ngFor="let experience of experienceYears" [ngValue]="experience.value">
                        {{experience.displayValue}}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6 select-border float-left">
                    <label>Education*</label>
                    <select class="form-control basic-select" formControlName="educationLevel"
                      [class.is-invalid]="(form.controls['educationLevel']?.errors || form.controls['educationLevel']?.errors?.required)">
                      <option *ngFor="let educationLevel of lookupStore.educationLevels | async"
                        [ngValue]="educationLevel.id">{{educationLevel.value}}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 float-left">
                    <label>Rate ($)*</label>
                    <div class="row">
                      <div class="col-md-3 float-left">
                        <input type="text" class="form-control salary-input" formControlName="minimumSalary"
                          type="number" placeholder="min"
                          [class.is-invalid]="(form.controls['minimumSalary']?.errors || form.controls['minimumSalary']?.errors?.required)">
                      </div>
                      <div class="col-md-3 float-left">
                        <input type="text" class="form-control salary-input" formControlName="maximumSalary"
                          type="number" placeholder="max"
                          [class.is-invalid]="(form.controls['maximumSalary']?.errors || form.controls['maximumSalary']?.errors?.required)">
                      </div>
                      <div class="col-md-6 float-left">
                        <select class="form-control basic-select" formControlName="salaryType"
                          [class.is-invalid]="(form.controls['salaryType']?.errors || form.controls['salaryType']?.errors?.required)">
                          <option *ngFor="let salaryType of lookupStore.salaryTypes | async" [ngValue]="salaryType.id">
                            {{salaryType.value}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6 datetimepickers float-left">
                    <label>Expire Date*</label>
                    <div class="input-group">
                      <input class="form-control" placeholder="yyyy-mm-dd" name="dp" formControlName="expiryDate" [minDate]="minExpiryDate"
                        [class.is-invalid]="(form.controls['expiryDate']?.errors || form.controls['expiryDate']?.errors?.required)"
                        ngbDatepicker #d="ngbDatepicker">
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="user-dashboard-info-box">
            <div class="form-group mb-0">
              <h4 class="mb-3">Location</h4>
              <div class="form-row pb-2">
                <div class="custom-control custom-radio pr-5">
                  <input type="radio" class="custom-control-input" id="radio_remote" [value]="workTypes.REMOTE"
                    formControlName="workType"
                    [class.is-invalid]="(form.controls['workType']?.errors || form.controls['workType']?.errors?.required)">
                  <label class="custom-control-label" for="radio_remote">{{locationTypes.REMOTE}}*</label>
                </div>
                <div class="custom-control custom-radio">
                  <input type="radio" class="custom-control-input" id="radio_onsite" [value]="workTypes.ON_SITE"
                    formControlName="workType"
                    [class.is-invalid]="(form.controls['workType']?.errors || form.controls['workType']?.errors?.required)">
                  <label class="custom-control-label" for="radio_onsite">{{locationTypes.ON_SITE}}*</label>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>City *</label>
                  <input type="text" class="form-control" formControlName="city"
                    [class.is-invalid]="(form.controls['city']?.errors || form.controls['city']?.errors?.required)">
                </div>
                <div class="form-group col-md-6">
                  <label>Country *</label>
                  <select class="form-control basic-select" formControlName="country"
                    [class.is-invalid]="(form.controls['country']?.errors || form.controls['country']?.errors?.required)">
                    <option *ngFor="let country of lookupStore.countries | async" [ngValue]="country.id">
                      {{country.name}}</option>
                  </select>
                </div>
                <div class="form-group mb-0 col-md-12">
                  <label>Address</label>
                  <input type="text" class="form-control" formControlName="location">
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-primary save-btn" (click)="save()" [disabled]="!form.valid">Save</button>
          <div *ngIf="!form.valid" class="form-validation-msg">Please fill in all the required fields(*).</div>
        </div>
      </div>
    </form>
  </div>
</section>
